import { render, staticRenderFns } from "./CouponPrint.vue?vue&type=template&id=71180a90&scoped=true"
import script from "./CouponPrint.vue?vue&type=script&lang=js"
export * from "./CouponPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71180a90",
  null
  
)

export default component.exports